import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function UserMergeRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserMerge', {
		url: '/admin/merge_users',
		controllerAs: 'vm',
		controller: UserMergeCtrl,
		templateUrl: '/ng/hub/User/Merge/UserMergeCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/User/Merge/UserMergeCtrl.css'),
			$title: () => 'UserMerge page',
		},
	});
}

export class UserMergeCtrl {
	constructor(Api, Logger, modal) {
		'ngInject';
		this.name = 'UserMerge';
		// save injections
		this.Api = Api;
		this.Logger = Logger;
		this.modal = modal;
		this.reset();
	}

	mergePreviewData() {
		this.previewMerge = true; // This opens the modal
		this.mergePreviewLoading = true;
		const userIdToKeep = parseInt(this.keepUser);
		const userIdToDelete = parseInt(this.deleteUser);
		const headers = { 'Submit-As-Job': true };
		const params = { keep: userIdToKeep, discard: userIdToDelete };
		// Hit API as Job
		this.Api.get('/users/merge_preview', params, headers)
			.then(response => {
				if (response.success === true) {
					// Store job ID and kick it off to the checkJobStatus function
					const jobId = response.job_id;
					this.checkJobStatus(jobId);
				}
			})
			.catch(error => {
				this.Logger.write('USER_MERGE_DEBUG', 'Error getting merge preview data:', error);
			});
	}

	checkJobStatus(jobId) {
		// Set interval to hit this API every 5 seconds
		let timer = setInterval(() => {
			this.Api.get(`/api_jobs/${jobId}`, { uuid: jobId })
				.then(response => {
					if (response.completed_at) {
						// parse data into a useable javascript object
						let data = JSON.parse(response.response_body);
						// Pass to this function as well as timer to end interval.
						this.getMergePreviewData(data, timer);
					}
				})
				.catch(error => {
					this.Logger.write('USER_MERGE_DEBUG', 'Error getting merge preview data:', error);
				});
		}, 5000);
	}

	getMergePreviewData(data, timer) {
		// Kill the interval since we have the data we want now.
		clearInterval(timer);
		// Loop through the data and assign each user the correct data
		data.forEach(item => {
			if (item.matched_records) {
				this.matchedRecords = item.matched_records;
			} else if (item.id === 'keep') {
				this.userToKeep = item;
			} else {
				this.userToDelete = item;
			}
		});
		// Turn off loading screen
		this.mergePreviewLoading = false;
		// Display the user data!
		this.hasMergeData = true;
	}

	executeMerge() {
		this.disableContentContainer = true;
		this.modal.confirm({ text: 'Are you sure you want to merge these users? This action cannot be undone' }).then(() => {
			const userIdToKeep = parseInt(this.keepUser);
			const userIdToDelete = parseInt(this.deleteUser);
			// Kick off and show loading screen while users are merged.
			this.mergeUsersLoading = true;
			// Hit API to start merge
			const headers = { 'Submit-As-Job': true };
			const params = { keep: userIdToKeep, discard: userIdToDelete };
			this.Api.get('/users/merge', params, headers)
				.then(response => {
					if (response.success === true) {
						// Store job ID and kick it off to the checkExecuteMergeStatus function
						const jobId = response.job_id;
						this.checkExecuteMergeStatus(jobId);
					}
				})
				.catch(error => {
					this.Logger.write('USER_MERGE_DEBUG', 'Error merging users:', error);
				});
		});
	}

	checkExecuteMergeStatus(jobId) {
		// Set interval to hit this API every 5 seconds
		let timer = setInterval(() => {
			this.Api.get(`/api_jobs/${jobId}`, { uuid: jobId })
				.then(response => {
					if (response.completed_at) {
						// parse data into a useable javascript object
						let data = JSON.parse(response.response_body);
						// Pass to this function as well as timer to end interval.
						this.executeMergeResults(data, timer);
					}
				})
				.catch(error => {
					this.Logger.write('USER_MERGE_DEBUG', 'Error executing merge:', error);
				});
		}, 5000);
	}

	executeMergeResults(data, timer) {
		clearInterval(timer);
		if (data.success === true) {
			this.hasMergeData = false;
			this.mergeUsersLoading = false;
			this.mergeSuccessData = data;
		} else {
			this.mergeError = data;
		}
	}

	reset() {
		this.userToKeep = null;
		this.userToDelete = null;
		this.mergeSuccessData = null;
		this.keepUser = '';
		this.deleteUser = '';
		this.previewMerge = false;
		this.hasMergeData = false;
		this.mergeError = false;
		this.mergeUsersLoading = false;
		this.mergePreviewLoading = false;
		this.disableContentContainer = false;
		this.matchedRecords = null;
	}
}
